import React from "react";
import { ChantSelect, ChantCheckbox } from "../../../../../../CommonComponents";

const DonationStep = ({
  partnerId,
  allPartners,
  donationAutorenewal,
  backgroundColor,
  handlePartnerChange,
  handleNext,
  setDonationAutorenewal,
}) => {
  const partnerOptions = allPartners.map((partner) => ({
    value: partner.id,
    label: partner.name,
  }));

  return (
    <>
      <div className="reg-section" style={{ marginTop: 24 }}>
        <h4 className="reg-section-title">Donation Settings</h4>

        <p className="reg-donation-intro">
          If you wish to request donations, select one featured partner to
          appear during the registration process. See the Partners section to
          set up partners.
        </p>

        <div className="reg-donation-fields">
          <ChantSelect
            label={<span>Partner (Donations)</span>}
            value={partnerId || undefined}
            onChange={(value) => handlePartnerChange(value || "")}
            placeholder="Select partner"
            options={partnerOptions}
            allowClear
          />

          <div className="reg-autorenewal-row">
            <div style={{ paddingTop: 2 }}>
              <ChantCheckbox
                checked={donationAutorenewal}
                onChange={(e) => {
                  setDonationAutorenewal(e.target.checked);
                }}
              />
            </div>
            <div>
              <label className="reg-field-label" style={{ marginBottom: 4 }}>
                Offer auto-renewal?
              </label>
              <p className="reg-autorenewal-text">
                If offering auto-renewal for member packages you can offer the
                same for donations. Consider setting the supporter group as the
                &apos;partner&apos; and not changing this from season to season
                &ndash; so that auto-renewals always go to the same cause.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Navigation */}
      <div className="reg-step-nav">
        <button
          className="reg-btn reg-btn-back"
          type="button"
          onClick={(e) => {
            e.preventDefault();
            handleNext("donationStep", "formFieldStep");
          }}
        >
          Back
        </button>
        <button
          className="reg-btn reg-btn-next"
          type="button"
          style={{ backgroundColor: backgroundColor || "#1890ff" }}
          onClick={(e) => {
            e.preventDefault();
            handleNext("donationStep", "previewStep");
          }}
        >
          Submit
        </button>
      </div>
    </>
  );
};

export default DonationStep;
